'use client';

import { cn } from '../../../lib/utils';
import { CloseIcon } from '../../../icons';
import React from 'react';

type OnClose = () => void | ((state: boolean) => void);

type ModalBase = {
  children: React.ReactNode;
  title?: string;
  padding?: string;
  maxWidth?: string;
  cntrClassName?: string;
  titleClassName?: string;
  closeBtnClassName?: string;
  closeIconSize?: string;
};

type NonCloseable = {
  onClose?: never;
  isCloseTouchOutside?: never;
  showCloseButton?: never;
};

type Closeable = {
  onClose: OnClose;
  isCloseTouchOutside?: boolean;
  showCloseButton?: boolean;
};

type ModalProps = ModalBase & (NonCloseable | Closeable);

export const Modal = ({
  children,
  showCloseButton,
  onClose,
  isCloseTouchOutside,
  title,
  padding,
  maxWidth,
  cntrClassName,
  titleClassName,
  closeBtnClassName,
  closeIconSize,
}: ModalProps) => {
  return (
    <div
      className="
        fixed inset-0 
        bg-gscale-950 bg-opacity-50 
        flex items-center justify-center
        z-[99999]
      "
      onClick={() => {
        if (isCloseTouchOutside) {
          onClose();
        }
      }}
    >
      <div
        className={cn(
          `
          rounded-2xl p-[1rem] w-full max-w-md
          border border-gscale-400 bg-gscale-25
        `,
          padding && `p-[${padding}]`,
          maxWidth && `max-w-[${maxWidth}]`,
          cntrClassName && cntrClassName,
        )}
        onClick={e => e.stopPropagation()}
      >
        <div
          className={cn(
            `
            flex justify-between items-center mb-[1rem]
            text-lg font-semibold
            `,
            titleClassName && titleClassName,
          )}
        >
          <h3>{title ?? ''}</h3>
          {showCloseButton && (
            <button
              onClick={onClose}
              className={cn(
                `text-gray-500 hover:text-gray-700`,
                closeBtnClassName && closeBtnClassName,
              )}
            >
              <CloseIcon
                className={cn(
                  `w-5 h-5`,
                  closeIconSize && `w-[${closeIconSize}] h-[${closeIconSize}]`,
                )}
              />
            </button>
          )}
        </div>

        {children}
      </div>
    </div>
  );
};

Modal.displayName = 'Modal';
